export { default } from './HoverSlot.js';
